import { CellContext } from '@tanstack/react-table';
import { getTableMeta, PurchaseOrderRow } from '../../helpers';
import { useCurrencies } from 'contexts/OptionsContext/useCurrencies';
import { asMoneyWithoutZeros } from 'helpers';
import { SkeletonizedValue } from '@round/ui-kit';
import styles from './AmountCell.module.css';
import { isEmptyObject } from 'utility/utility';

type Context = CellContext<PurchaseOrderRow, any>;

const AmountCell = ({ row: { original }, table }: Context) => {
    const { getCurrencyById } = useCurrencies();
    const { isLoading: isFetching } = getTableMeta(table);
    const currency = getCurrencyById(original.currency_id);
    const isLoading = isFetching && isEmptyObject(original);

    return (
        <div className={styles.container}>
            <p className={styles.amount}>
                <SkeletonizedValue isInitialized={!isLoading} width="7rem">
                    {asMoneyWithoutZeros(original.amount, currency)}
                </SkeletonizedValue>
            </p>
            {currency && (
                <p className={styles.currency}>
                    <SkeletonizedValue isInitialized={!isLoading} width="4rem">
                        {currency.name}
                    </SkeletonizedValue>
                </p>
            )}
        </div>
    );
};

export default AmountCell;
